// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hDzZW","left":"styles_left__1sw-V","desktopActions":"styles_desktopActions__3wXa1","title":"styles_title__1ZO8t"};